import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Old address for the full reservations list. The list now lives on the
 * account page's Reservations tab, so this sends the guest there with
 * whatever else was in the query string. A plain temporary redirect: this is
 * a signed-in page, so there is no search ranking to consolidate.
 */
export const Route = createFileRoute("/_authed/account/reservations")({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/account",
      search: { ...(search as Record<string, unknown>), tab: "bookings" },
      replace: true,
    });
  },
});
